import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
//import { useLocation } from "react-router-dom";
import React from "react";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BodyClassName from "react-body-classname";
import LanguageSwitcher from "./components/languageSwitcher/languageSwitcher";

import { SurveyContext } from "./store/survey-context";

import HomePage from "./pages/Homepage/Start/index";
import Questionnaire from "./pages/Questionnaire/index";
import IntroScreen from "./pages/Homepage/IntroScreen/IntroScreen";
import WelcomeScreen from "./pages/Homepage/WelcomeScreen/WelcomeScreen";
import Recommendations from "./pages/YourJurney/recommendations/index";
import Finish from "./pages/YourJurney/finish";
import SurveyConfirmation from "./pages/SurveyConfirmation/surveyConfirmation";
import Rings from "./pages/YourJurney/Rings/Rings";

import checkAuth from "./api/auth";
import Loader from "./components/loader/loader";
import ErrorPage from "./components/errorPage/errorPage";
import MacallanAPI from "./api/macallan";
import { setAppBackground } from "./utils";

import $ from "jquery";
import smoothscroll from "smoothscroll-polyfill";
import { Helmet } from "react-helmet";
import Dialog from "./components/dialog/Dialog";
import Cta from "./components/cta/Cta";
smoothscroll.polyfill();

const DASHBOARD_URL = process.env.REACT_APP_MACALLAN_DASHBOARD;

if (process.env.REACT_APP_DEBUG === "1") {
  document.onkeypress = function (e) {
    e = e || window.event;
    const charCode = e.charCode || e.keyCode,
      character = String.fromCharCode(charCode);

    if (character === "*") {
      $(".tp-dfwv").toggleClass("show-helper");
      $(".tp-area-helper").toggleClass("show-helper");
    }
  };
} else {
  console.log = function () {};
  console.info = function () {};
}

export default function MTCApp() {
  const {
    setAccessToken,
    setError,
    setMacallanWhiskies,
    replaceMarkedForLater,
    setUserProfile,
    error,
    userProfile,
    dialogOpen,
    setDialogOpen,
  } = useContext(SurveyContext);

  // TODO remove the "lng" param from URL
  /*
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete("lng");
  const searchString = searchParams.toString().replace(/%2C/g, ',');
  const newUrl = (searchString.length ? `?${searchString}` : '') + window.location.hash;
  console.log(newUrl);
  window.history.replaceState(null, '', newUrl);

  https://stackoverflow.com/questions/62032050/how-to-remove-query-param-with-react-hooks
  */

  // check login status - redirect
  useEffect(() => {
    // main background image
    setAppBackground(`Hero-1b.png`);

    checkAuth()
      .then(
        (accessToken) => {
          setAccessToken(accessToken);

          //  run API call to get user's info and list of Macallan's whiskies
          const api = new MacallanAPI(accessToken);

          Promise.all([api.getProfileAndAnswers(), api.getMacallanWhiskies()])
            .then((values) => {
              if (
                typeof values[0] === "undefined" ||
                typeof values[1] === "undefined"
              ) {
                setError(true);
                return;
              }
              // Macallan whiskies
              setMacallanWhiskies(values[1]);

              // profile and answers and "marked for later"
              replaceMarkedForLater(values[0].markedForLater);
              setUserProfile({ ...values[0] });
            })
            .catch((error) => {
              setError(true);
            });
        },
        (error) => {
          setAccessToken(null);

          // in working application - redirect to The Macallan "My Macallan journey" page
          if (process.env.REACT_APP_REQUIRE_AUTH === "1") {
            window.location.href = process.env.REACT_APP_MACALLAN_REDIRECT;
          } else {
            // temporary set data for anonymous user
            setUserProfile({
              firstName: "Anonymous",
              lastName: "",
              overallPercentageComplete: 0,
            });
          }
        }
      )
      .catch((e) => {
        setError(true);
      });

    // close exit dialog (or open, if manually browsed to #exit)
    window.addEventListener(
      "hashchange",
      function () {
        setDialogOpen(window.location.hash === "#exit");
      },
      false
    );

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && window.location.hash === "#exit") {
        window.history.back();
      }
    });
  }, [
    setAccessToken,
    setError,
    setMacallanWhiskies,
    replaceMarkedForLater,
    setUserProfile,
    setDialogOpen,
  ]);

  const { t, ready, i18n } = useTranslation("common", { useSuspense: false });

  if (error !== false) {
    let navPageLink = window.location.origin + "/questionnaire";
    return (
      <>
        <Router>
          <ErrorPage
            title={t("error_page.title_500")}
            description={t("error_page.description_500")}
            absoluteLink="true"
            buttonTitle={t("error_page.button")}
            path={navPageLink}
          />
        </Router>
      </>
    );
  }

  if (userProfile === null || !ready) {
    return <Loader text={t("app.loading")} />;
  }

  const exitDialog = (
    <Dialog
      open={dialogOpen}
      header={t("dialog.exit_journey")}
      description={t("dialog.exit_confirm")}
      logo={false}
    >
      <Cta
        tagName="a"
        ctaClass="cta--primary"
        href={DASHBOARD_URL.replace("/en/", `/${i18n.language.toLowerCase()}/`)}
        iconClass="icon-account"
      >
        {t("button.exit_dashboard")}
      </Cta>
      <Cta
        tagName="button"
        ctaClass="cta--secondary"
        iconClass="icon-rings"
        onClick={() => window.history.back()}
      >
        {t("button.continue_journey")}
      </Cta>
    </Dialog>
  );

  const surveyCompleted =
    userProfile.percentageCompletionValues?.overall === 100;

  // Load ReCaptcha code if it doesn't already exist.
  if (document.getElementById('mmj-recaptcha-script') === null) {
    const script = document.createElement("script");

    script.src = "//www.google.com/recaptcha/api.js?render=" + process.env.REACT_APP_RECAPTCHA_V3_KEY;
    script.async = true;
    script.id = 'mmj-recaptcha-script';

    document.body.appendChild(script);
  }

  return (
    <>
      <Helmet>
        <html lang={i18n.resolvedLanguage} />
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
        <meta property="og:title" content={t("meta.title")} />
        <meta property="og:description" content={t("meta.description")} />
      </Helmet>
      {exitDialog}
      {dialogOpen && <BodyClassName className="has-dialog" />}
      <Router>
        <div className="page-content">
          <div className="tp-dfwv">
            <LanguageSwitcher />
          </div>
          <Switch>
            <Route exact path="/">
              <BodyClassName className="ishome" />
              <HomePage
                productName1={t("start.line1")}
                productName2={t("start.line2")}
                productName3={t("start.line3")}
                btnTitle={t("button.begin")}
                showLogo={"true"}
              />
            </Route>
            <Route path="/intro">
              <IntroScreen />
            </Route>
            <Route path="/welcome">
              <WelcomeScreen />
            </Route>

            <Route path="/questionnaire">
              <Questionnaire />
            </Route>
            <Route path="/recommendations">
              {surveyCompleted ? (
                <>
                  <BodyClassName className="recommendations-view" />
                  <Recommendations />
                </>
              ) : (
                <Redirect to="/" />
              )}
            </Route>
            <Route path="/finish">
              {surveyCompleted ? (
                <>
                  <BodyClassName className="finish-view" />
                  <Finish />
                </>
              ) : (
                <Redirect to="/" />
              )}
            </Route>
            <Route path="/survey-confirmation">
              {surveyCompleted ? (
                <>
                  <SurveyConfirmation />
                </>
              ) : (
                <Redirect to="/" />
              )}
            </Route>
            <Route path="/rings">
              {surveyCompleted ? <Rings /> : <Redirect to="/" />}
            </Route>
            <Route>
              <ErrorPage
                title={t("error_page.title_404")}
                description={t("error_page.description_404")}
                path="/questionnaire"
                absoluteLink="false"
                buttonTitle={t("error_page.button")}
              />
            </Route>
          </Switch>
        </div>
      </Router>
    </>
  );
}
